module.exports = __webpack_public_path__ + "static/Bookatable-9daabe17d70c6be436c82830b9747645.svg";